import { render, staticRenderFns } from "./DeleteUnrelClaimsTransaction.vue?vue&type=template&id=69d8dce5&"
import script from "./DeleteUnrelClaimsTransaction.vue?vue&type=script&lang=js&"
export * from "./DeleteUnrelClaimsTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports